export const search_list = () => {
	return [
  // {
  //   type: 'select',
  //   label: '发布位置',
  //   props: 'publishType',
  //   selectData: publish_type
  // },
  {
    type: "input",
    label: "课程名称",
    props: "title",
  },
  {
    type: "input",
    label: "讲师名称",
    props: "teacher",
  },
  {
    type: "date",
    label: "时间",
    props: "date",
  }
]
}
// export const search_list = [
//   {
//     type: 'select',
//     label: '发布位置',
//     props: 'publishType',
//     selectData: [
//       {
//         label: '全部',
//         value: '0'
//       },
//       {
//         label: '找培训',
//         value: '1'
//       },
//       {
//         label: '校企首页',
//         value: '2'
//       },
//       {
//         label: '浙江树人大学(浙树帮帮)',
//         value: 5
//       },
//       {
//         label: '浙江大学(GDT产教融合)',
//         value: 6
//       }
//     ]
//   },
//   {
//     type: "input",
//     label: "课程名称",
//     props: "title",
//   },
//   {
//     type: "input",
//     label: "讲师名称",
//     props: "teacher",
//   },
//   // {
//   //   type: "select",
//   //   label: "课程上下架",
//   //   props: "upStatus",
//   //   selectData: [
//   //     {
//   //       label: "待上架",
//   //       value: 0,
//   //     },
//   //     {
//   //       label: "已上架",
//   //       value: 1,
//   //     },
//   //     {
//   //       label: "已下架",
//   //       value: 2,
//   //     },
//   //   ],
//   // },
//   {
//     type: "date",
//     label: "时间",
//     props: "date",
//   },
// ]; 
export const tableColumns = [
  {
    title: "课程名称",
    value: "title",
    header_align: "center",
    align: "center",
    width: 180,
  },
  // {
  //   title: "发布位置",
  //   value: "publish_name",
  //   header_align: "center",
  //   align: "center",
  //   width: 160,
  // },
  {
    title: "首页推荐",
    value: "is_recommend_text",
    header_align: "center",
    align: "center",
    width: 100,
  },
  {
    title: "讲师名称",
    value: "teacher",
    header_align: "center",
    align: "center",
    width: 150,
  },
  {
    title: "课程价格",
    value: "price",
    header_align: "center",
    align: "center",
    width: 150,
  },
  // {
  //   label:  '折扣',
  //   props: 'price',
  // },
  {
    title: "创建日期",
    value: "createdAt",
    header_align: "center",
    align: "center",
    width: 180,
  },
  {
    title: "课程时间",
    value: "course_time_text",
    header_align: "center",
    align: "center",
    width: 300,
  },
  {
    title: "课程状态",
    value: "status_text",
    header_align: "center",
    align: "center",
    width: 140,
  },
];
export const actionGroup = [
  {
    name: "上架",
    flag: "wait",
    rules: "upStatus==0&&data.status!=2",
    is_delete: true,
    deleteTitle: "确认上架么？",
  },
  {
    name: "下架",
    flag: "grounding",
    rules: "upStatus==1&&data.status!=2",
    is_delete: true,
    deleteTitle: "确认下架么？",
  },
  {
    name: "重新上架",
    flag: "offShelf",
    rules: "upStatus==2&&data.status!=2",
    is_delete: true,
    deleteTitle: "确认要重新上架么？",
  },
  {
    name: "编辑",
    rules: "status!=2",
    flag: "examine",
  },
  {
    name: "详情",
    flag: "details",
  },
  {
    name: "同步",
    rules: "status!=2",
    flag: "synchronization",
  },
];
export const form_list = (optionDisabledValue, publish_type = []) => {
  return  [
    {
      type: 'input',
      label: '课程名称',
      props: 'title',
      disabled: true,
    },
    {
      type: 'select',
      label: '小程序位置',
      props: 'publish_list',
      required:true,
      propsConfig: {
        multiple: true,
        optionDisabled:true,
        optionDisabledValue:optionDisabledValue
      },
      selectData: publish_type
    },
  ] 

}
